import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const orgchartTeamFieldPack: FieldPack = {
  id: 'orgchart-team',
  name: 'Team Fields',
  description: 'Team entity fields for team assembly and new team design workflows',
  version: '1.0.0',
  fields: [
    {
      id: 'name',
      label: 'Team Name',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 100,
      required: true,
      sensitivity: 'public',
    },
    {
      id: 'teamCode',
      label: 'Team Code',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 90,
      sensitivity: 'internal',
    },
    {
      id: 'department',
      label: 'Parent Department',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['organization'],
      priority: 85,
      sensitivity: 'internal',
    },
    {
      id: 'teamLead',
      label: 'Team Lead',
      type: FieldType.TEXT,
      tags: ['identity'],
      priority: 80,
      sensitivity: 'public',
    },
    {
      id: 'teamType',
      label: 'Team Type',
      type: FieldType.SELECT,
      tags: ['organization'],
      priority: 75,
      options: [
        { value: 'permanent', label: 'Permanent' },
        { value: 'project', label: 'Project-Based' },
        { value: 'cross_functional', label: 'Cross-Functional' },
        { value: 'task_force', label: 'Task Force' },
        { value: 'committee', label: 'Committee' },
      ],
      sensitivity: 'public',
    },
    {
      id: 'memberCount',
      label: 'Members',
      type: FieldType.NUMBER,
      tags: ['workforce'],
      priority: 70,
      min: 0,
      sensitivity: 'internal',
    },
    {
      id: 'maxSize',
      label: 'Max Size',
      type: FieldType.NUMBER,
      tags: ['workforce'],
      priority: 65,
      min: 0,
      sensitivity: 'internal',
    },
    {
      id: 'formationDate',
      label: 'Formed',
      type: FieldType.DATE,
      tags: ['timeline'],
      priority: 60,
      sensitivity: 'internal',
    },
    {
      id: 'status',
      label: 'Status',
      type: FieldType.SELECT,
      tags: ['organization'],
      priority: 55,
      options: [
        { value: 'active', label: 'Active' },
        { value: 'forming', label: 'Forming' },
        { value: 'disbanded', label: 'Disbanded' },
        { value: 'on_hold', label: 'On Hold' },
      ],
      sensitivity: 'internal',
    },
    {
      id: 'description',
      label: 'Description',
      type: FieldType.TEXT,
      tags: ['notes'],
      priority: 50,
      multiline: true,
      sensitivity: 'internal',
    },
  ],
};
